import { Empty } from '@allswipes/ui';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout';
import { AuditScreen, BrandScreen } from './screens/Brand';
import { PackScreen } from './screens/Pack';
import { TeamScreen } from './screens/Team';
import { CampaignDetailScreen } from './screens/CampaignDetail';
import { CampaignsScreen } from './screens/Campaigns';
import { ClaimsScreen } from './screens/Claims';
import { DashboardScreen } from './screens/Dashboard';
import { EconomicsScreen } from './screens/Economics';
import { InviteScreen } from './screens/Invite';
import { LoginScreen } from './screens/Login';
import { ReviewsScreen } from './screens/Reviews';
import { WizardScreen } from './screens/Wizard';
import { useConsole } from './session';

export function App() {
  const { signedIn, loading } = useConsole();

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100dvh' }}>
        <span className="sub">Загружаем кабинет…</span>
      </div>
    );
  }

  // Весь кабинет за входом: публичных страниц здесь нет.
  if (!signedIn) {
    return (
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        {/* Приглашение открывают до того, как аккаунт существует: это
            единственная страница кабинета, доступная без входа. */}
        <Route path="/invite/:token" element={<InviteScreen />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<DashboardScreen />} />
      <Route path="/campaigns" element={<CampaignsScreen />} />
      <Route path="/campaigns/:id" element={<CampaignDetailScreen />} />
      <Route path="/campaigns/:id/economics" element={<EconomicsScreen />} />
      <Route path="/create" element={<WizardScreen />} />
      <Route path="/create/:id" element={<WizardScreen />} />
      <Route path="/claims" element={<ClaimsScreen />} />
      <Route path="/reviews" element={<ReviewsScreen />} />
      <Route path="/brand" element={<BrandScreen />} />
      <Route path="/team" element={<TeamScreen />} />
      <Route path="/campaigns/:id/pack" element={<PackScreen />} />
      <Route path="/audit" element={<AuditScreen />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/invite/:token" element={<Navigate to="/" replace />} />
      <Route
        path="*"
        element={
          <Layout title="Не найдено">
            <Empty icon="search" title="Такой страницы нет" />
          </Layout>
        }
      />
    </Routes>
  );
}
